import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from '@appfolio/react-gears';

const RememberMyDevice = ({ checked, onChange, onKeyDown }) => (
  <FormGroup check>
    <Input
      type="checkbox"
      id="rememberMyDevice"
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      onKeyDown={onKeyDown}
    />
    <Label check for="rememberMyDevice">Do not ask this device for a code for 30 days</Label>
  </FormGroup>
);

RememberMyDevice.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default RememberMyDevice;
